export interface IWarehouseShopCategoryData {
    id: number;
    name: string;
}

export default class WarehouseShopCategoryData {
    public id: number;
    public name: string;

    constructor(data: IWarehouseShopCategoryData) {
        this.id = Number(data.id);
        this.name = data.name;
    }
}